let Zajax = {};

Zajax.post = function (url, params, responseHandler) {
  var xhttp1 = new XMLHttpRequest();
  xhttp1.onreadystatechange = function (response) {
    if (this.readyState === 4 && this.status === 200) {
      let response = JSON.parse(this.responseText)
      responseHandler(response)
    }
  };

  xhttp1.open("POST", url, true);
  xhttp1.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
  xhttp1.send(JSON.stringify(params));
}

Zajax.get = function (url, responseHandler) {
  var xhttp1 = new XMLHttpRequest();
  xhttp1.onreadystatechange = function (response) {
    if (this.readyState === 4 && this.status === 200) {
      let response = JSON.parse(this.responseText)
      responseHandler(response)
    }
  };

  xhttp1.open("GET", url, true);
  xhttp1.send();
}

Zajax.multipartPost = function (url, formData, headers, responseHandler, errorHandler) {
  var xhttp1 = new XMLHttpRequest();
  xhttp1.onreadystatechange = function (response) {
    if (this.readyState === 4) {
      if (this.status === 200) {
        let response = JSON.parse(this.responseText);
        responseHandler(response);
      } else if (errorHandler) {
        errorHandler();
      }
    }
  };

  xhttp1.open("POST", url, true);
  if (headers) {
    Object.keys(headers).forEach(key => {
      xhttp1.setRequestHeader(key, headers[key]);
    });
  }
  xhttp1.send(formData);
}

export default Zajax;
